/*
 *  -----------------------------------------------------------------------
 *    <copyright file="custom-menu.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from 'react';
import { showMaxLength } from '@utils/filter';

import './styles.scss';
import { textToId } from '@utils/automation-test-helpers';

const CustomMenuDetails = ({ menuOptions, noDataMessage }: any) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
                className="bars-menu"
                data-testid="bars-menu"
            >
                <FontAwesomeIcon icon={['fal', 'bars']} className="fa-lg bars-icon" />
            </Button>
            <Menu
                id="simple-menu"
                className="bars-menu-items-review-risk"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                getContentAnchorEl={null}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {menuOptions?.length ? (
                    menuOptions.map((item: any, index: number) => (
                        <MenuItem
                            key={index}
                            disabled={item.enabled !== undefined ? !item.enabled : false}
                            onClick={() => {
                                item.onClick();
                                handleClose();
                            }}
                            data-testid={`menu-item-${textToId(item.label, index)}`}
                        >
                            {showMaxLength(item.label, 50)}
                        </MenuItem>
                    ))
                ) : (
                    <div className="no-items-wrapper">
                        <p>{noDataMessage ?? ''}</p>
                    </div>
                )}
            </Menu>
        </div>
    );
};

export default CustomMenuDetails;
